import { render, staticRenderFns } from "./SaveButtonOptions.vue?vue&type=template&id=518f3a66&"
import script from "./SaveButtonOptions.vue?vue&type=script&lang=js&"
export * from "./SaveButtonOptions.vue?vue&type=script&lang=js&"
import style0 from "./SaveButtonOptions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports